import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import Client from 'src/models/AP/Client';
import _ from 'lodash';
import TsdiClient from 'src/models/AP/Client';
import './GenerateInvoicesDialog.css';
import Invoice from 'src/components/project-billing/models/InvoiceMaster';
import { InvoiceGroupCoverLetter } from '../models/InvoiceGroupCoverLetter';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import DialogList from 'src/dialogs';
import TsdiInvoiceGroupRequest from 'src/components/project-billing/models/InvoiceGroupRequest';

interface IInvoiceGroupCoverLetterDialogProps {
    dialogName: string;
    hideDialog: () => void;
    onCancel?: () => void;
    onGenerateCoverLetter?: (payload: InvoiceGroupCoverLetter) => void;
    onUpdateIgRequest?: (payload: InvoiceGroupCoverLetter) => void;
    resetClientSearchOptions?: () => void;
    setClientSearchTerm?: (keyword: string) => void;
    incrementClients?: () => void;
    clients?: Client[];
    previewDocument?: (payload: InvoiceGroupCoverLetter) => void;
    showAddVendorDialog?: () => void;
    setSelectedClient?: (clientNumber: TsdiClient) => void;
    style?: React.CSSProperties;
    addNewClient?: boolean;
    defaultClient?: number;
    mileageRate?: number;
    offices?: Array<{value: number | string, label: string}>;
    periodTypes?: { code: number, description: string}[];
    currentUser?: number | null;
    payPeriod?: string | null;
    setRelaunchDialog?: (dialog: DialogList) => void;
    invoiceGroupRequests?: Array<TsdiInvoiceGroupRequest>;
}

const InvoiceGroupCoverLetterDialog = (props: IInvoiceGroupCoverLetterDialogProps) => {
    const { reset, register, errors, getValues, handleSubmit, formState } = useForm();
    const { isDirty } = formState;
    const [clientName, setClientName] = useState<string>(undefined);
    // const dispatch = useDispatch();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (Array.isArray(props.clients) && props.clients.length > 0) {
            setClientName(props.clients[0].clientName);
        }
    }, [props.clients]);

    useEffect(() => {
    if (
        Array.isArray(props?.invoiceGroupRequests) &&
        props.invoiceGroupRequests.length > 0
    ) {
        const row = props.invoiceGroupRequests[0];

        let letterDate = '';

        if (row.letterDate) {
        const d = new Date(row.letterDate);

        letterDate = new Date(
            d.getFullYear(),
            d.getMonth(),
            d.getDate() < 16
            ? 15
            : new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()
        )
            .toISOString()
            .split('T')[0];
        }

        reset({
        ...row,
        letterDate
        });
    }
    }, [props.invoiceGroupRequests, reset]);

    const onCreate = () => {
        // Initialization here
    };

    const onCancel = () => {
        props.hideDialog();
    };

    const onUpdateIgRequest = (data: InvoiceGroupCoverLetter) => {
        if (typeof props?.onUpdateIgRequest === 'function') {
            props.onUpdateIgRequest(data);
        }
    };

    const onGenerateCoverLetter = (data: Invoice) => {
        console.log(data);
        const payload = getValues();
        const transformedPayload = new InvoiceGroupCoverLetter();
        transformedPayload.groupIrNumber = payload.groupIrNumber;
        transformedPayload.letterDate = payload?.letterDate ? new Date(payload?.letterDate) : new Date();
        transformedPayload.clientName = payload.clientName;
        transformedPayload.clientContact = payload.clientLandman;
        transformedPayload.clientAddress = payload.clientAddress;
        transformedPayload.clientAddress2 = payload.clientAddress2;
        transformedPayload.clientAddress3 = payload.clientAddress3;
        transformedPayload.salutation = payload?.salutation;
        transformedPayload.firstParagraph = payload?.firstParagraph;
        transformedPayload.secondParagraph = payload?.secondParagraph;
        transformedPayload.projectName = payload?.projectName;
        transformedPayload.wellName = payload?.wellName;
        transformedPayload.parcelNumbers = payload?.parcelNumber;
        transformedPayload.qlsNumber = payload?.qlsNumber;
        transformedPayload.afeNumber = payload?.afeNumber;
        transformedPayload.municipalities = payload?.municipalities;
        transformedPayload.signatureName = payload?.signatureName;
        transformedPayload.signatureTitle = payload?.signatureTitle;

        props.onGenerateCoverLetter(transformedPayload);
    };

    return (
        <>
        <Dialog title={'Invoice Group Cover Letter'} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ maxHeight: '90vh', width: '50%' }}>
        <form id={'createClientForm'} onSubmit={handleSubmit(onUpdateIgRequest)}>
            <div style={{display: 'inline-block', marginTop: '1rem'}}>

                <div style={{display: 'flex', flexDirection: 'column', whiteSpace: 'nowrap'}}>
                    <RHFInputBox
                        labelStyle={{marginRight: '4.5rem', whiteSpace: 'nowrap'}}
                        label="Group No"
                        labelOnLeft={true}
                        defaultVal={(() => {
                            if (Array.isArray(props.invoiceGroupRequests) && props.invoiceGroupRequests.length > 0) {
                                return props.invoiceGroupRequests[0].groupIrNumber.toString();
                            } else {
                                return '';
                            }                            
                        })()}
                        name={`groupIrNumber`}
                        type={'number'}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '20%' }}
                        readOnly={true}
                    />
                    <RHFInputBox
                        labelStyle={{marginRight: '4.5rem', whiteSpace: 'nowrap'}}
                        label="Letter Date"
                        labelOnLeft={true}
                        defaultVal={
                            (() => {
                                if (Array.isArray(props?.invoiceGroupRequests) &&
                                            props.invoiceGroupRequests.length > 0 &&
                                            props.invoiceGroupRequests[0].letterDate) {
                                const d = new Date(props.invoiceGroupRequests[0].letterDate);
                                return new Date(
                                d.getFullYear(),
                                d.getMonth(),
                                d.getDate() < 16
                                    ? 15
                                    : new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()
                                ).toISOString().split('T')[0];
                            } else {
                                return '';
                            }
                            })()
                        }
                        name={`letterDate`}
                        type="date"
                        register={register}
                        rules={{ required: 'Letter Date required' }}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '35%' }}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'Client Name:'}
                        labelOnLeft={true}
                        name={'clientName'}
                        defaultVal={clientName}
                        style={{whiteSpace: 'nowrap', width: '70%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        rules={{ required: 'Client required' }}
                        isRequired={true}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'Client Landman:'}
                        labelOnLeft={true}
                        name={'clientContact'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '40%'}}
                        register={register}
                        rules={{ required: 'Client Landman required' }}
                        isRequired={true}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'Client Address:'}
                        labelOnLeft={true}
                        name={'clientAddress'}
                        style={{whiteSpace: 'nowrap', width: '70%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        rules={{ required: 'Client Address required' }}
                        isRequired={true}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        name={'clientAddress2'}
                        style={{marginLeft: '10.5rem', whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        name={'clientAddress3'}
                        style={{whiteSpace: 'nowrap', width: '100%'}}
                        bodyStyle={{marginLeft: '10.5rem', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '30%'}}
                        register={register}
                        errors={errors}
                    />
                    <div style={{display: 'flex', flexDirection: 'row', whiteSpace: 'nowrap', justifyContent: 'flex-start'}}>
                        <RHFInputBox
                            bodyClassName={'project-billing form-group'}
                            name={'clientCity'}
                            label={'City:'}
                            labelOnLeft={true}
                            style={{whiteSpace: 'nowrap', width: '100%'}}
                            bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '20%'}}
                            register={register}
                            errors={errors}
                        />
                        <RHFInputBox
                            bodyClassName={'project-billing form-group'}
                            name={'clientState'}
                            label={'State:'}
                            labelOnLeft={true}
                            style={{whiteSpace: 'nowrap', width: '100%'}}
                            bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '10%'}}
                            register={register}
                            errors={errors}
                        />
                        <RHFInputBox
                            bodyClassName={'project-billing form-group'}
                            label={'Zip:'}
                            type={'text'}
                            labelOnLeft={true}
                            name={'clientZip'}
                            style={{whiteSpace: 'nowrap', width: '100%'}}
                            bodyStyle={{marginLeft: '4rem', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '15%'}}
                            register={register}
                            errors={errors}
                        />
                    </div>
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'Salutation:'}
                        defaultVal={'Dear Valued Client,'}
                        labelOnLeft={true}
                        name={'salutation'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '30%'}}
                        register={register}
                        isRequired={true}
                        errors={errors}
                    />
                    <RHFTextArea
                        label={'First Paragraph:'}
                        name={'firstParagraph'}
                        style={{whiteSpace: 'nowrap', width: '100%', resize: 'none'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '100%'}}
                        register={register}
                        isRequired={true}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        defaultVal={'Susquehanna Abstracting Project'}
                        type={'text'}
                        label={'Project Name:'}
                        labelOnLeft={true}
                        name={'projectName'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                    />                
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'Well Name:'}
                        labelOnLeft={true}
                        name={'wellName'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        isRequired={true}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'Parcel Number(s):'}
                        labelOnLeft={true}
                        name={'parcelNumbers'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        isRequired={true}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'QLS Number(s):'}
                        labelOnLeft={true}
                        name={'qlsNumbers'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        isRequired={true}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'AFE Number:'}
                        labelOnLeft={true}
                        name={'afeNumber'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        isRequired={true}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'Municipalities:'}
                        labelOnLeft={true}
                        name={'municipalities'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        isRequired={true}
                        errors={errors}
                    />
                    <RHFTextArea
                        label={'Second Paragraph:'}
                        name={'secondParagraph'}
                        style={{whiteSpace: 'nowrap', width: '100%', resize: 'none'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '100%'}}
                        register={register}
                        isRequired={true}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'Signature:'}
                        labelOnLeft={true}
                        name={'signatureName'}
                        style={{whiteSpace: 'nowrap', width: '100%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '30%'}}
                        register={register}
                        isRequired={true}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        defaultVal={'Billing Clerk'}
                        label={'Signature Title:'}
                        labelOnLeft={true}
                        name={'signatureTitle'}
                        style={{whiteSpace: 'nowrap', width: '100%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '30%'}}
                        register={register}
                        isRequired={true}
                        errors={errors}
                    />
                </div>
            </div>
                <div className="project-billing form-row" style={{marginTop: '2rem', marginLeft: '33%', textAlign: 'center'}}>
                <Button
                    className="blue-hover-button"
                    type={'button'}
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Generate'}
                    onClick={(e) => onGenerateCoverLetter(e as Invoice)}
                />
                <Button
                    className="blue-hover-button"
                    type={'button'}
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Preview'}
                    onClick={() => {
                        props.setRelaunchDialog(DialogList.EDIT_IG_COVER_LETTER);
                        props.previewDocument(getValues());
                    }}
                />
                <Button
                    className="blue-hover-button"
                    type={'submit'}
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={isDirty ? 'Save Changes' : 'OK'}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => onCancel()}
                />
                </div>
            </form>

        </Dialog>
        </>
    );
};

export default InvoiceGroupCoverLetterDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/InvoiceGroupCoverLetterDialog.tsx